export default "__VITE_ASSET__BVP4O_f3__"